// Based of off https://github.com/miketheprogrammer/xml-escape and updated for typescript and testing purposes

const htmlEscapeMap = {
  '>': '&gt;',
  '<': '&lt;',
  "'": '&apos;',
  '"': '&quot;',
  '&': '&amp;',
}

const xmlescape = (string: string): string => {
  // eslint-disable-next-line
  const ignore = ''.replace(/[^&"<>\']/g, '')
  const pattern = '([&"<>\'])'.replace(new RegExp(`[${ignore}]`, 'g'), '')
  const escapedString = string.replace(
    new RegExp(pattern, 'g'),
    (item) => htmlEscapeMap[item]
  )
  return escapedString
}

export default xmlescape
